import React, { useEffect, useState } from 'react';
import {
  StepContainer,
  StepLabelContainer,
  StepPrimaryLabel,
  StepSecondaryLabel,
  StepIcon,
  Step,
  StepConnector,
  StepProgressBar,
  StepWrapper,
  IconButton,
  IconChevronLeft,
  Divider,
  Grid,
  Row,
  Column,
  PreventFocus,
  SideSheetContainer,
  SideSheetMainWrapper,
  SideSheetOverlay

} from 'cdk-radial';
import GetOrdersWrapper from './GetOrdersWrapper';
import { useOktaAuth } from '@okta/okta-react';
import PartOrderDetailsWrapper from './PartOrderDetailsWrapper';
import ShippingDetailsWrapper from './ShippingDetailsWrapper';
import { useHistory } from 'react-router-dom';
import { URL_ROUTES } from '../../adapters/constants';
import { useAppState } from '../../store';
import EditPartOrder from './EditPartOrder';
import { partItem } from '../../common/types';
import fetchDropDownData from '../../adapters/services/fetchDropDownData';
import getEmptyForNull from '../../utils/utils';
import { drop } from 'lodash';


export default function NewOrderTransmissionWrapper(): JSX.Element {
 
  const history = useHistory();
  const alreadySelectedGroup = useAppState();

  const [activeStep, setActiveStep] = useState(1);
  const steps = [
    {
      label: 'Step 1',
      secondary_label: 'Select Orders'
    },
    {
      label: 'Step 2',
      secondary_label: 'Review Order Items'
    },
    {
      label: 'Step 3',
      secondary_label: 'Shipping Preference'
    }
  ];

  const [header, setHeader] = useState<string>('');
  const [editedRows, setEditedRows] = useState([]);
  const [singleEdit, setSingleEdit] = useState(false);
  const [checkRows, setCheckedRows] = useState<partItem[]>();
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(alreadySelectedGroup.selectedGroup);
  const {isPanelCollapsed, setPanelCollapsed } = useAppState();
  const [dropDownData,setDropDownData] = useState([]);
  const { authState } = useOktaAuth();
  

  useEffect(() => {
    

    const getData = async () => {       
        const data:any = await fetchDropDownData(`Bearer ${getEmptyForNull(authState?.accessToken?.accessToken)}`);
        setDropDownData(data);       
    }; 
    getData();  
  }, []);


  const handlePartEditClick = (rowData: any) => {
    // Set the selected item to the state
    setPanelCollapsed(false);
    setEditedRows(rowData);
    setSingleEdit(true);
    setHeader('Edit Order Item');

  };

  const BulkUpdateClick = (partItems : partItem[]) => {
    setPanelCollapsed(false);
    setSingleEdit(false);
    if (Array.isArray(partItems) && partItems.length > 0) {
      const updatedCheckedRows = partItems.filter((row: any) => row.isSelected);
      setCheckedRows(updatedCheckedRows);
      setHeader(`Bulk Orders (${updatedCheckedRows.length})`);
    } 
  }

  

  const handleNavigationClick = () => {
    history.push(URL_ROUTES.landingPage);
  };

 
  return (
    <>
      
      <SideSheetMainWrapper dataTestId="side-sheet-modal" isModal   >
        <SideSheetOverlay isCollapsed={isPanelCollapsed} />
        <SideSheetContainer
          dataTestId="side-sheet-modal-container"
          isCollapsed={isPanelCollapsed}
          isModal
        >
          <EditPartOrder
            onClick={() => setPanelCollapsed(!isPanelCollapsed)}
            selectedOrders={selectedOrders}
            setSelectedOrders={setSelectedOrders}
            header={header}
            editedRows={editedRows}
            singleEdit={singleEdit}
            checkRows={checkRows}
            dropDownData={dropDownData}
          />
        </SideSheetContainer>
        <div style={{alignItems: 'stretch', width: '100%',overflow :'auto'}}>
       
          <PreventFocus isEnabled={!isPanelCollapsed}>

          
          <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ paddingTop: '15px' }}>
          <IconButton
          data-testid="navigationButton"
            ariaLabel="Account"
            onClick={handleNavigationClick}
            icon={<IconChevronLeft />}
          />
        </div>
        <div>
          <h3>Start New Order Transmission</h3>
        </div>
      </div>
      <Divider style={{opacity:"70%"}}></Divider>
      <Grid>
        <Row>
          <StepContainer data-testid="stepper">
            <StepWrapper>
              {steps.map((step, i) => {
                const index = i + 1;
                const isLastStep = index === steps.length;
                return (
                  <React.Fragment key={index}>
                    <Step
                      isActive={activeStep === index}
                      isComplete={activeStep > index}
                      onClick={() => setActiveStep(index)}
                      aria-labelledby={`label${index}`}
                      aria-disabled={activeStep < index}
                      aria-controls={`step-content-${index}`}
                      data-testid={`step-${index}`}
                    >
                      <StepIcon
                        dataTestId={`step-${index}-icon`}
                        stepNumber={index}
                      />
                      <StepLabelContainer>
                        <StepPrimaryLabel
                          data-testid={`step-${index}-primary-label`}
                          id={`label${index}`}
                        >
                          {step.label}
                        </StepPrimaryLabel>
                        <StepSecondaryLabel
                          data-testid={`step-${index}-secondary-label`}
                        >
                          {step.secondary_label}
                        </StepSecondaryLabel>
                      </StepLabelContainer>
                    </Step>
                    {!isLastStep && <StepConnector aria-hidden="true" />}
                  </React.Fragment>
                );
              })}
            </StepWrapper>
            <StepProgressBar totalSteps={3} currentStep={activeStep} />
          </StepContainer>
          {activeStep === 1 && (
            <Grid>
              <Row>
                <Column l={12} m={12} s={12} xl={12} xs={12}>
                  <GetOrdersWrapper
                    setActiveState={setActiveStep}
                    activeState={activeStep}
                    setSelectedOrders={setSelectedOrders}
                    selectedOrders={selectedOrders}
                    selectedGroup={selectedGroup}
                    setSelectedGroup={setSelectedGroup}
                  />
                </Column>
              </Row>
            </Grid>
          )}
          {activeStep === 2 && (
            <Grid>
              <Row>
                <Column l={12} m={12} s={12} xl={12} xs={12}>
                  <PartOrderDetailsWrapper
                    setActiveState={setActiveStep}
                    activeState={activeStep}
                    setSelectedOrders={setSelectedOrders}
                    selectedOrders={selectedOrders}
                    handlePartEditClick ={handlePartEditClick}
                    BulkUpdateClick={BulkUpdateClick}
                    
                  />
                </Column>
              </Row>
            </Grid>
          )}
          {activeStep === 3 && (
            <Grid>
              <Row>
                <Column l={12} m={12} s={12} xl={12} xs={12}>
                  <ShippingDetailsWrapper
                    setActiveState={setActiveStep}
                    activeState={activeStep}
                    selectedGroup={selectedGroup}
                    setSelectedGroup={setSelectedGroup}
                    selectedOrders={selectedOrders}
                    setSelectedOrders={setSelectedOrders}
                    dropDownData ={dropDownData}
                  />
                </Column>
              </Row>
            </Grid>
          )}
        </Row>
      </Grid>
          </PreventFocus>
          </div>
        
      </SideSheetMainWrapper>


    </>
  );
}
